import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createCountrySchema = z.object({
  locale: z.string().min(1),
  name: z.string().min(1),
  currencyCode: z.string().min(1),
  currencyName: z.string().min(1),
  currencySymbol: z.string().optional(),
});

export class CreateCountryDto extends createZodDto(createCountrySchema) {}
